import { AfterViewInit, Component, OnDestroy, OnInit, signal, WritableSignal, ViewChild, ChangeDetectorRef, afterNextRender, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { InputComponent } from "../../shared/input/input.component";
import { SelectedComponent } from "../../shared/selected/selected.component";
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { SecurityService } from '../../services/security.service';
import { ConfigBirthDate, ConfigInput, ConfigSelected, Department } from '../../interfaces/interfaces';
import { BirthdateComponent } from "../../shared/birthdate/birthdate.component";
import { adultValidator } from 'app/config/functions.shared';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader.service';
import { ModalComponent } from "../../shared/modal/modal.component";
import { ListsService } from '../../services/lists.service';
import { catchError, from, lastValueFrom, map, Observable, of } from 'rxjs';
import { ErrorScreenComponent } from "../../shared/error-screen/error-screen.component"; // Importación añadida
import { LogRedebanSoyyoService } from '../../services/log-redeban-soyyo.service';
import { RouteService } from '../../services/route.service';
import { HelpService } from '../../services/help.service';
import { WowComponent } from "app/shared/wow/wow.component";
import { OlimpiaService } from '../../services/olimpia.service';
import { BecomeService } from '../../services/become.service';
import { IdentityProviderCode, IdentityValidationProviderService } from '../../services/identity-validation-provider.service';
import { AutocompleteComponent } from 'app/shared/autocomplete/autocomplete.component';
import ROUTES from '../../config/settings.config';


@Component({
  selector: 'app-form-data-basic',
  imports: [
    InputComponent,
    SelectedComponent,
    BirthdateComponent,
    ReactiveFormsModule,
    CommonModule,
    ModalComponent,
    ErrorScreenComponent,
    WowComponent,
    FormsModule,
    AutocompleteComponent,
],
  templateUrl: './form-data-basic.component.html',
  styleUrl: './form-data-basic.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FormDataBasicComponent implements OnInit, AfterViewInit, OnDestroy {

  dataInputs: WritableSignal<ConfigInput[]> = signal([
    { label: '¿Comó te llamas?', subLabel: '', formName: 'fullname', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [ Validators.required, Validators.minLength(3), Validators.maxLength(35)], textError: 'Tu nombre debe tener más de 3 caracteres y no debe contener números ni caracteres especiales.'},
    { label: 'Número de Identificación', subLabel: '(Debes seleccionar primero el tipo de identificación)', formName: 'identification', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required, Validators.min(100000), Validators.max(10000000000)], textError: 'Debes digitar un número de identificación válido sin espacios ni separadores de miles.' },
    { label: 'Número de Celular', subLabel: '(para enviar códigos de seguridad)', formName: 'phone', placeholder: '', type: 'tel', defaultValue: '', enabled: true, validation: [ Validators.required, Validators.min(3000000000), Validators.max(3999999999)], textError: 'Tu numero debe tener 10 dígitos sin espacios.'},
    { label: 'Correo electrónico', subLabel: '', formName: 'email', placeholder: '', type: 'email', defaultValue: '', enabled: true, validation: [ Validators.required, Validators.email, this.miValidadorExtra], textError: 'Debes digitar un correo válido.'},
  ])

  dataSelected: WritableSignal<ConfigSelected[]> = signal([
        { label: 'Tipo de Identificación', subLabel: '', formName: 'identificationType', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [ Validators.required], textError: 'Por favor selecciona un elemento de la lista', options: signal([
          { value: 1, label: 'Cédula de Ciudadanía' }, 
          { value: 2, label: 'Cédula de Extranjería' },
          // { value: 5, label: 'Pasaporte' },
          { value: 48, label: 'Permiso de Protección temporal' },
        ]) },
        { label: 'Nacionalidad', subLabel: '', formName: 'nationalityId', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona una Nacionalidad', options: signal([]) },
    ])

  birthdateConfig = signal<ConfigBirthDate>({
    label: 'Fecha de nacimiento',
    subLabel: '',
    defaultValue: null,
    enabled: true,
    validation: [Validators.required, adultValidator],
  });

  showWowSignal: WritableSignal<boolean> = signal(false);
  showOlimpiaSignal: WritableSignal<boolean> = signal(false);
  showOlimpiaDepartmentSignal: WritableSignal<boolean> = signal(false);
  showBecomeSignal: WritableSignal<boolean> = signal(false);

  requiredValidator = null;

  form: FormGroup;
  currentStep = 1;
  step:number | null = null;
  titleError: string = '';
  descriptionError: string = '';
  errorActionLabel = 'Reintentar';
  showErrorAdvisor = true;
  identityBlocked = false;
  nextRoute: WritableSignal<string> = signal('');

  // Signals
  showTerms = signal(false);
  showModal = signal(false);
  recentlyOnboarding = signal(false);
  showAlert = signal(false);
  showError = signal(false);
  showBirthdateModal = signal(false);
  validatePerson = signal(false);
  showFaceGuide = signal(false);
  showResumeVinculation = signal(false);

  disabledButton = false;

  emailValidate = false;
  canContinue = true;
  hasValidationPerson = false;
  checkpoint:string = '';

  soyYoServicePercent = 90;

  validationOlimpiaUrl: SafeResourceUrl = '';
  intervalId: any;
  processGuid: string = '';
  validateWithOlimpia = false;
  olimpiaData: any = null;
  listDepartments: any = null;
  listCities = signal<any[]>([]);

  becomeUserId: string = '';
  becomeSession: {
    accessToken: string;
    userId: string;
    contractId: string;
    country: string;
    docType: string;
  } | null = null;
  private becomeButtonEl: HTMLElement | null = null;
  private becomeSdkLoading: Promise<void> | null = null;
  private becomeFrameObserver: MutationObserver | null = null;
  private becomeAutoClickTimer: any = null;
  private becomeFrameOpened = false;
  private becomeCycleFinished = false;
  /** Become se abre al cerrar los consejos, no mientras el modal sigue visible. */
  private openBecomeAfterFaceGuide = false;
  private providerFallbackUsed = false;
  /** Asesor con Become: ocultar fecha/lugar que el validador completa desde el documento. */
  usesBecomeIdentity = signal(false);

  selectedDepartment: Department | null = null;

  STEP_CONFIRM_DATA_IN_CURRENT_MODAL = 1;
  STEP_SHOW_CAMERA_IN_CURRENT_MODAL = 2;

  departmentSelected = false;
  selectedDepartmentName: string = '';

  constructor(
    private _router: Router,
    private title: Title,
    private _securityService: SecurityService,
    private _loaderService: LoaderService,
    private _logRedebanSoyyoService: LogRedebanSoyyoService,
    public _listsService: ListsService,
    private _routeService: RouteService,
    private _helpService: HelpService,
    private _cdr: ChangeDetectorRef,
    private olimpiaService: OlimpiaService,
    private becomeService: BecomeService,
    private identityValidationProviderService: IdentityValidationProviderService,
    private sanitizer: DomSanitizer,

  ){
    this.title.setTitle('Onboarding Digital | Datos Básico');


    this.form = new FormGroup({
        fullname: new FormControl(null, Validators.required),
        identificationType: new FormControl(null, Validators.required),
        identification: new FormControl(null, Validators.required),
        expeditionDepartment: new FormControl(null, Validators.required),
        expeditionCity: new FormControl(null, Validators.required),
        expeditionCityId: new FormControl(null, Validators.required),
        phone: new FormControl(null, Validators.required),
        email: new FormControl(null, Validators.required),
        birthday: new FormControl(null, Validators.compose([
          Validators.required,
          this.mustBe18YearsOrOlder.bind(this),
        ])),
        nationalityId: new FormControl(null),
        authorization: new FormControl(null, Validators.compose([
          Validators.requiredTrue
        ])),
      });

      this.form.get('birthday')?.valueChanges.subscribe((value: string | null) => {
        if (value) {
          setTimeout(() => {
            const birthdayControl = this.form.get('birthday');
            if (birthdayControl?.hasError('under18')) {
              birthdayControl.setValue(null);
            }
          });
        }
      });

      let previousIdentificationType: number | null = null;

      this.form.get('identificationType')?.valueChanges.subscribe((value: any) => {
        const numericValue = Number(value);

        this.updateNationalityField(value, previousIdentificationType === 1);
        previousIdentificationType = numericValue;

        this.form.patchValue({
          expeditionDepartment: null,
          expeditionCity: null,
          expeditionCityId: null
        }, { emitEvent: false });

        this.departmentSelected = false;
        this.selectedDepartmentName = '';
        this.listCities.set([]);

        if (numericValue !== 1) {
          this.setDefaultExpeditionCity();
        }

        this.syncBecomeHiddenFieldValidators();
      });

      this.form.get('expeditionDepartment')?.valueChanges.subscribe((value) => {

        if (!value) {
            this.departmentSelected = false;
            this.selectedDepartmentName = '';
            this.form.get('expeditionCity')?.setValue(null, { emitEvent: false });
            this.form.get('expeditionCityId')?.setValue(null, { emitEvent: false });
            this.listCities.set([]);
        }
        else if (value !== this.selectedDepartmentName) {
            const departmentExists = this.listDepartments.some(
              ( dept: { departamento: any; }) => dept.departamento === value
            );

            if (departmentExists) {
                this.selectedDepartmentName = value;
                this.departmentSelected = true;
                this.getCitiesByDepartment(value);
                this.form.get('expeditionCity')?.setValue(null, { emitEvent: false });
                this.form.get('expeditionCityId')?.setValue(null, { emitEvent: false });
            }
        }
      });

    this.nextRoute.set(this._routeService.getNextRoute(this._router.url) ?? '');
  }

  mustBe18YearsOrOlder(control: AbstractControl): ValidationErrors | null {
    if (control.value !== undefined && control.value !== null && control.value !== '') {
      const dateValue = new Date(control.value);
      const now = new Date();
      const minimumAge = new Date();
      minimumAge.setFullYear(now.getFullYear() - 18);

      if (dateValue > minimumAge) {
        return { under18: true };
      }
    }
    return null;
  }

  async ngOnInit(){
    const authRoute = localStorage.getItem('route');
    const currentUrl = this._router.url;
    if(!authRoute) {
      this._router.navigateByUrl('');
    }
    if(authRoute && currentUrl !== authRoute) {
      await this._router.navigateByUrl(authRoute);
    } else{
      this._loaderService.show('Validando información, por favor espere...');
      let leftBasic = false;
      try {
        leftBasic = await this.redirectToAddressWhenCheckpointAdvanced();
      } catch (error) {
        console.error(error);
      } finally {
        this._loaderService.hide();
      }
      if (leftBasic) {
        return;
      }
      this._helpService.show();
      this.getData();
      this.getDepartments();
      void this.resolveIdentityProviderForForm();
    }
  }

  private async resolveIdentityProviderForForm(): Promise<void> {
    try {
      const provider = await lastValueFrom(this.identityValidationProviderService.resolveForOnboarding());
      this.usesBecomeIdentity.set(provider === 'BECOME');
    } catch (error) {
      console.error('Error resolving identity provider for form', error);
      this.usesBecomeIdentity.set(false);
    }
    this.syncBecomeHiddenFieldValidators();
  }

  /**
   * Con Become no pedimos fecha ni lugar de expedición/nacimiento en basic:
   * verifyValidate completa birth, birth_place y lugar de expedición.
   */
  private syncBecomeHiddenFieldValidators(): void {
    const birthdayControl = this.form.get('birthday');
    const expeditionDepartment = this.form.get('expeditionDepartment');
    const expeditionCity = this.form.get('expeditionCity');
    const expeditionCityId = this.form.get('expeditionCityId');
    const identificationType = Number(this.form.get('identificationType')?.value);
    const hideBirthAndPlace = this.usesBecomeIdentity();

    if (hideBirthAndPlace) {
      birthdayControl?.clearValidators();
      birthdayControl?.setValue(null, { emitEvent: false });
      expeditionDepartment?.clearValidators();
      expeditionCity?.clearValidators();
      expeditionCityId?.clearValidators();

      if (identificationType === 1) {
        expeditionDepartment?.setValue(null, { emitEvent: false });
        expeditionCity?.setValue(null, { emitEvent: false });
        expeditionCityId?.setValue(null, { emitEvent: false });
        this.departmentSelected = false;
        this.selectedDepartmentName = '';
        this.listCities.set([]);
      }
    } else {
      birthdayControl?.setValidators(
        Validators.compose([Validators.required, this.mustBe18YearsOrOlder.bind(this)])
      );
      expeditionDepartment?.setValidators(Validators.required);
      expeditionCity?.setValidators(Validators.required);
      expeditionCityId?.setValidators(Validators.required);

      if (identificationType !== 1 && identificationType) {
        this.setDefaultExpeditionCity();
      }
    }

    birthdayControl?.updateValueAndValidity({ emitEvent: false });
    expeditionDepartment?.updateValueAndValidity({ emitEvent: false });
    expeditionCity?.updateValueAndValidity({ emitEvent: false });
    expeditionCityId?.updateValueAndValidity({ emitEvent: false });
  }

  getDepartments() {
    this._listsService.getDepartments().subscribe({
      next: (response: any) => {
        this.listDepartments = response.ubications || [];
      },
      error: (error: any) => {
        console.error('Error fetching departments', error);
      }
    });
  }

  onDepartmentSelected(departmentName: string): void {
    this.form.get('expeditionDepartment')?.setValue(departmentName, { emitEvent: false });
    this.selectedDepartmentName = departmentName;
    this.departmentSelected = true;
    this.form.get('expeditionCity')?.setValue(null, { emitEvent: false });
    this.form.get('expeditionCityId')?.setValue(null, { emitEvent: false });
    this.getCitiesByDepartment(departmentName);
  }

  onDepartmentInputChange(value: string): void {

    if (!value || value.trim() === '') {
        this.departmentSelected = false;
        this.selectedDepartmentName = '';

        this.form.get('expeditionCity')?.setValue(null, { emitEvent: false });
        this.form.get('expeditionCityId')?.setValue(null, { emitEvent: false });

        this.form.get('expeditionDepartment')?.setValue(null, { emitEvent: false });

        this.listCities.set([]);
    }
    else {
        this.departmentSelected = false;
        this.form.get('expeditionCity')?.setValue(null, { emitEvent: false });
        this.form.get('expeditionCityId')?.setValue(null, { emitEvent: false });
        this.listCities.set([]);
    }
  }

  getCitiesByDepartment(departmentName: string): void {
    this._listsService.getCities(departmentName).subscribe({
        next: (response: any) => {
            setTimeout(() => {
                this.listCities.set(response.ubications || []);

                const currentCityId = this.form.get('expeditionCityId')?.value;

                if (currentCityId) {
                    const cityInList = this.listCities().find(
                        (city: any) => Number(city.id) === Number(currentCityId)
                    );

                    if (cityInList && !this.form.get('expeditionCity')?.value) {
                        this.form.patchValue({
                            expeditionCity: cityInList.simple_name || cityInList.name
                        }, { emitEvent: false });
                    }
                }

                if (this.listCities().length === 0) {
                    console.log('No hay ciudades disponibles para este departamento');
                }
            });
        },
        error: (error: any) => {
            console.error('Error fetching cities', error);
            setTimeout(() => {
                this.listCities.set([]);
            });
        }
    });
  }

  onCitySelected(cityId: number): void {
    const normalizedCityId = Number(cityId);
    this._listsService.getExpeditionCityById(cityId).subscribe({
        next: (response: any) => {
            const cityData = response.ubication || response.data || response;
            setTimeout(() => {
                this.form.patchValue({
                    expeditionCityId: normalizedCityId,
                    expeditionCity: cityData.simple_name || cityData.name
                }, { emitEvent: false });
                console.log('City data loaded:', cityData);
            });
        },
        error: (error) => {
            console.error('Error fetching city details', error);
        }
    });
  }


  setDefaultExpeditionCity(): void {
    const defaultCityId = 927;
    this.getExpeditionCity(defaultCityId);
    setTimeout(() => {
      this.form.patchValue({
        expeditionCityId: defaultCityId
      }, { emitEvent: false });
    }, 1000);
  }

  miValidadorExtra(control: AbstractControl): ValidationErrors | null {
    const value: string = control.value;

    if (!value) return null;

    // Expresión regular para validar que el correo termine en punto seguido de un TLD válido
    // Acepta correos que terminen en .algo donde "algo" son letras (mínimo 2 caracteres)
    const emailTldRegex = /\.([a-zA-Z]{2,})$/;

    if (!emailTldRegex.test(value)) {
      return { tldInvalido: true };
    }

    return null;
  }

  async checkPercentages() {
    const blocked = await this.validateOnboardingToday();
    if (blocked) {
      return;
    }

    this._loaderService.show('Preparando validación de identidad, por favor espere...');
    const provider = await lastValueFrom(this.identityValidationProviderService.resolveForOnboarding());
    this._loaderService.hide();

    this.providerFallbackUsed = false;
    this.showFaceGuide.set(true);
    if (provider === 'BECOME') {
      this.openBecomeAfterFaceGuide = true;
      return;
    }
    this.startProvider(provider);
  }

  continueAfterFaceGuide() {
    this.showFaceGuide.set(false);
    if (!this.openBecomeAfterFaceGuide) {
      return;
    }
    this.openBecomeAfterFaceGuide = false;
    this.startProvider('BECOME');
  }

  private startProvider(provider: IdentityProviderCode) {
    if (provider === 'BECOME') {
      this.onSubmitBecome();
    } else {
      this.onSubmitOlimpia();
    }
  }

  /** Solo para fallas técnicas al iniciar; un rechazo de identidad no debe reintentarse con otro proveedor. */
  private handleProviderStartFailure(failed: IdentityProviderCode, error?: unknown) {
    console.error(`Fallo al iniciar ${failed}`, error);
    this._loaderService.hide();
    const alternative: IdentityProviderCode = failed === 'OLIMPIA' ? 'BECOME' : 'OLIMPIA';

    if (!this.providerFallbackUsed) {
      this.providerFallbackUsed = true;
      this.usesBecomeIdentity.set(alternative === 'BECOME');
      this.syncBecomeHiddenFieldValidators();
      this.saveLog('Error', `00-${failed} start failed, fallback to ${alternative}`, null);
      this.startProvider(alternative);
      return;
    }

    this.failMessage('No fue posible iniciar la validación de identidad. Intente de nuevo más tarde o comuníquese con su asesor.');
  }

  selectService() {
    const randomValue = Math.random() * 100;
    if (randomValue < this.soyYoServicePercent) {
      this.onSubmitOlimpia();
    } else {
      this.onSubmitOlimpia();
    }
  }

  async getCheckpoint() {
    this._loaderService.show('Validando información, por favor espere...');
    try {
      const leftBasic = await this.redirectToAddressWhenCheckpointAdvanced();
      if (leftBasic) {
        return;
      }

      const blocked = await this.saveAndValidateBlock();
      if (blocked) {
        return;
      }

      const response: any = await lastValueFrom(this._securityService.getCheckpoint());
      this.checkpoint = response?.checkpoint ?? '';
      this.showModalNext();
    } catch (error) {
      console.error(error);
    } finally {
      this._loaderService.hide();
    }
  }

  private checkpointStep(checkpoint: string): number | null {
    const suffix = checkpoint.split('_').pop() ?? '';
    if (!/^\d+$/.test(suffix)) {
      return null;
    }
    return Number(suffix);
  }

  private async redirectToAddressWhenCheckpointAdvanced(): Promise<boolean> {
    const response: any = await lastValueFrom(this._securityService.getCheckpoint());
    const checkpoint = String(response?.checkpoint ?? '');
    this.checkpoint = checkpoint;

    if (checkpoint === 'LIST_ERROR_06') {
      return false;
    }

    const step = this.checkpointStep(checkpoint);
    const basicRoute = ROUTES.find((route) => route.path === '/app/basic');
    const stillOnBasic = basicRoute?.checkpoint.includes(checkpoint) ?? false;
    if (step == null || step < 5 || stillOnBasic) {
      return false;
    }

    localStorage.setItem('route', '/app/address');
    await this._router.navigateByUrl('/app/address');
    return true;
  }

  showModalNext(){
    this.currentStep = this.STEP_CONFIRM_DATA_IN_CURRENT_MODAL;
    this.showModal.set(true);
  }

  private syncResumeVinculationState(): void {
    const stepNumber = Number(this.step);
    const isListError = this.checkpoint === 'LIST_ERROR_06';
    this.showResumeVinculation.set(
      !Number.isNaN(stepNumber) && stepNumber >= 5 && !isListError
    );
  }

  private getResumeRoute(): string {
    const matchedRoute = [...ROUTES]
      .reverse()
      .find((route) => route.checkpoint.includes(this.checkpoint));

    if (matchedRoute && matchedRoute.step >= 4) {
      return matchedRoute.path;
    }

    return '/app/address';
  }

  async resumeVinculation(): Promise<void> {
    if (this.disabledButton) {
      return;
    }

    this._loaderService.show('Validando información, por favor espere...');
    try {
      const blocked = await this.saveAndValidateBlock();
      if (blocked) {
        return;
      }

      const targetRoute = this.getResumeRoute();
      localStorage.setItem('olimpiaPassed', '1');
      localStorage.setItem('route', targetRoute);
      this._router.navigateByUrl(targetRoute);
    } finally {
      this._loaderService.hide();
    }
  }

  ngAfterViewInit(): void {
    this._loaderService.hide();
  }

  ngOnDestroy(): void {
    this.hideBecome();
  }

  private allNationalities: { value: string | number; label: string }[] = [];

  requiresNationality(): boolean {
    const type = Number(this.form.get('identificationType')?.value);
    return type === 2 || type === 5 || type === 48;
  }

  private updateNationalityField(identificationType: string | number | null, resetAutoAssignedNationality = false): void {
    const numericValue = Number(identificationType);
    const nationalityControl = this.form.get('nationalityId');

    if (numericValue === 1) {
      nationalityControl?.setValue(1, { emitEvent: false });
      nationalityControl?.clearValidators();
    } else if (numericValue === 2 || numericValue === 5 || numericValue === 48) {
      if (resetAutoAssignedNationality && nationalityControl?.value === 1) {
        nationalityControl?.setValue(null, { emitEvent: false });
      }
      nationalityControl?.setValidators(Validators.required);
      this.loadNationalities();
    } else {
      nationalityControl?.clearValidators();
      nationalityControl?.setValue(null, { emitEvent: false });
    }

    nationalityControl?.updateValueAndValidity({ emitEvent: false });
  }

  private loadNationalities(): void {
    if (this.allNationalities.length > 0) {
      this.applyNationalityOptions(this.allNationalities);
      return;
    }

    this._listsService.getNationalities().subscribe({
      next: (response: { value: string | number; label: string }[]) => {
        this.allNationalities = response ?? [];
        this.applyNationalityOptions(this.allNationalities);
      },
      error: (error: any) => {
        console.error('Error fetching nationalities', error);
      }
    });
  }

  private applyNationalityOptions(nationalities: { value: string | number; label: string }[]): void {
    const identificationType = Number(this.form.get('identificationType')?.value);
    const options = this.filterNationalities(nationalities, identificationType);
    const nationalitySelect = this.dataSelected().find((select) => select.formName === 'nationalityId');
    nationalitySelect?.options.set(options);

    const nationalityControl = this.form.get('nationalityId');
    const currentValue = nationalityControl?.value;
    const stillAvailable = options.some((option) => String(option.value) === String(currentValue));
    const nextValue = stillAvailable ? currentValue : '';

    if (!stillAvailable) {
      nationalityControl?.setValue(null, { emitEvent: false });
      nationalityControl?.updateValueAndValidity({ emitEvent: false });
    }

    this.dataSelected.update((selects) =>
      selects.map((select) =>
        select.formName === 'nationalityId'
          ? { ...select, defaultValue: nextValue }
          : select
      )
    );
  }

  private filterNationalities(
    nationalities: { value: string | number; label: string }[],
    identificationType: number
  ): { value: string | number; label: string }[] {
    if (identificationType === 48) {
      return nationalities.filter((option) => this.isVenezuelanNationality(option.label));
    }

    if (identificationType === 2 || identificationType === 5) {
      return nationalities.filter((option) => !this.isColombianNationality(option));
    }

    return nationalities;
  }

  private isVenezuelanNationality(label: string): boolean {
    return this.normalizeNationalityLabel(label).includes('venez');
  }

  private isColombianNationality(option: { value: string | number; label: string }): boolean {
    return Number(option.value) === 1 || this.normalizeNationalityLabel(option.label).includes('colomb');
  }

  private normalizeNationalityLabel(label: string): string {
    return label
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  handleSelect(event: {formName: string, value: string | number}) {
    this.form.get(event.formName)?.setValue(event.value);
  }

  hideWow(){
    localStorage.setItem('olimpiaPassed', '1');
    this.showWowSignal.set(false);
    localStorage.setItem('route', this.nextRoute());
    this._router.navigateByUrl(this.nextRoute());
  }

  hideOlimpia(){
    this.showOlimpiaSignal.set(false);
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  hideBecome(){
    this.becomeCycleFinished = true;
    this.showBecomeSignal.set(false);
    this.clearBecomeAutoOpenTimers();
    this.cleanupBecomeButton();
    this.stopBecomeFrameObserver();
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  hideOlimpiaDepartment(){
    this.showOlimpiaDepartmentSignal.set(false);
  }

  async next() {
    localStorage.setItem('route', this.nextRoute());
    await this._router.navigateByUrl(this.nextRoute());
  }

  handleBirthdate(event: { year: string; month: string; day: string } | null) {
    if (!event) {
      this.form.get('birthday')?.setValue(null);
      this.form.get('birthday')?.updateValueAndValidity();
      return;
    }

    const month = String(event.month).padStart(2, '0');
    const day = String(event.day).padStart(2, '0');
    const birthdayValue = `${event.year}-${month}-${day}`;
    this.form.get('birthday')?.setValue(birthdayValue);
    this.form.get('birthday')?.updateValueAndValidity();

    setTimeout(() => {
      const birthdayControl = this.form.get('birthday');
      if (birthdayControl?.hasError('under18')) {
        this.showBirthdateModal.set(true);
      }
    });
  }

  sendBirthdate() {
    this.showBirthdateModal.set(false);
    this._loaderService.show('Guardando fecha de nacimiento...');
    const birthdate = this.form.get('birthday')?.value;
    this._securityService.setBirthdate(birthdate).subscribe({
      next: () => {
        this._loaderService.hide();
      },
      error: (error: any) => {
        this._loaderService.hide();
        console.error('Error setting birthdate', error);
      }
    });
  }

  handleValue(event: {formName:string, value:string | number}) {
    this.form.get(event.formName)?.setValue(event.value);

    if (event.formName === 'identification' && event.value) {
      void this.verifyBlockIdentification();
    }
  }

  async getExpeditionCity(expeditionCityId: number) {
    try {
        this._listsService.getExpeditionCityById(expeditionCityId).subscribe({
            next: (response: any) => {
                const cityData = response.ubication || response.data || response;
                if (cityData) {
                    this.selectedDepartmentName = cityData.departamento;
                    this.departmentSelected = true;

                    this.form.patchValue({
                        expeditionDepartment: cityData.departamento,
                        expeditionCityId: expeditionCityId,
                        expeditionCity: cityData.simple_name || cityData.name
                    }, { emitEvent: false });

                    this.getCitiesByDepartment(cityData.departamento);
                }
            },
            error: (error: any) => {
                console.error('Error fetching expedition city', error);
            }
        });
    } catch (error) {
        console.error('Error fetching expedition city', error);
        throw error;
    }
  }

  //Get Functions
  getData(){
    this._securityService.getTypedPersonData().subscribe({
      next: (response: any) => {
        this.checkpoint = response?.checkpoint ?? '';
        this.step = Number(response?.checkpoint?.split('_').pop());
        this.syncResumeVinculationState();
        const hasBasicData =
          response?.fullname &&
          response?.identificationType &&
          response?.identification &&
          response?.phone &&
          response?.email &&
          response?.nationalityId &&
          (this.usesBecomeIdentity() || response?.expeditionCityId);

        //Antes de hacer el patchValue, verificar que el response tenga los campos necesarios
        if(hasBasicData) {
          const expeditionCityId = response.expeditionCityId != null
            ? Number(response.expeditionCityId)
            : null;
          this.form.patchValue({
            fullname: response.fullname,
            identificationType: response.identificationType,
            identification: response.identification,
            phone: response.phone,
            email: response.email,
            birthday: response.birthday ?? null,
            nationalityId: response.nationalityId,
            expeditionCityId: expeditionCityId
          }, { emitEvent: false });

          if (response.birthday) {
            const [year, month, day] = String(response.birthday).split('-');
            this.birthdateConfig.set({
              label: 'Fecha de nacimiento',
              subLabel: '',
              defaultValue: year && month && day
                ? {
                    year: Number(year),
                    month: Number(month),
                    day: Number(day),
                  }
                : null,
              enabled: true,
              validation: [Validators.required, adultValidator],
            });
          }

          this.updateNationalityField(response.identificationType);
          if (expeditionCityId != null && !Number.isNaN(expeditionCityId)) {
            this.getExpeditionCity(expeditionCityId);
          }
          this.syncBecomeHiddenFieldValidators();

          // Actualizar signals para los componentes hijos
          this.dataInputs.update((inputs:any) =>
            inputs.map((input:any) => {
              const value = (response as any)[input.formName]; // busca por nombre de campo
              return {
                ...input,
                defaultValue: value !== undefined ? value : input.defaultValue
              };
            })
          );

          this.dataSelected.update((selects:any) =>
            selects.map((selected:any) => {
              const value = (response as any)[selected.formName]; // busca por nombre de campo
              return {
                ...selected,
                defaultValue: value !== undefined ? value : selected.defaultValue
              };
            })
          );

          // Deshabilitar campos si step > 3
          if(this.step && this.step > 3) {
            this.form.patchValue({
              authorization: true,
            });

            this.form.get('authorization')?.disable();

            // Deshabilitar inputs a través de signals (usar set() para forzar nueva referencia)
            const disabledInputs = this.dataInputs().map((input: any) => ({
              label: input.label,
              subLabel: input.subLabel,
              formName: input.formName,
              placeholder: input.placeholder,
              type: input.type,
              defaultValue: input.defaultValue,
              enabled: false, // Forzar a false
              validation: input.validation,
              textError: input.textError
            }));
            this.dataInputs.set(disabledInputs);

            // Deshabilitar selects a través de signals (usar set() para forzar nueva referencia)
            const disabledSelects = this.dataSelected().map((select: any) => ({
              label: select.label,
              subLabel: select.subLabel,
              formName: select.formName,
              placeholder: select.placeholder,
              type: select.type,
              defaultValue: select.defaultValue,
              enabled: false, // Forzar a false
              validation: select.validation,
              textError: select.textError,
              options: select.options
            }));
            this.dataSelected.set(disabledSelects);

            this.birthdateConfig.update((config) => ({
              ...config,
              enabled: false,
            }));

            // Usar setTimeout para asegurar que Angular procese los cambios del signal
            setTimeout(() => {
              // Forzar detección de cambios para que los componentes hijos reciban los nuevos valores
              this._cdr.detectChanges();
            }, 0);

            this.emailValidate = true;
            if(this.checkpoint === 'LIST_ERROR_06') {
              this.canContinue = false;
            }
            this.hasValidationPerson = true;
          }
        }
      },
      error: (error: any) => {
        console.error('Error fetching typed person data', error);
      }
    })
  }

  private async validateOnboardingToday(): Promise<boolean> {
    const identification = this.form.get('identification')?.value as string;

    try {
      const response: any = await lastValueFrom(
        this._securityService.validateOnboardingTodayByIdentification(identification)
      );

      if (response.findToday === true) {
        this.recentlyOnboarding.set(true);
        this.showModal.set(false);
        this.currentStep = this.STEP_CONFIRM_DATA_IN_CURRENT_MODAL;
        return true;
      }

      this.recentlyOnboarding.set(false);
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  private async saveAndValidateBlock(): Promise<boolean> {
    const identificationBlocked = await this.verifyBlockIdentification();
    if (identificationBlocked) {
      return true;
    }

    const {
      identificationType,
      identification,
      email,
      phone,
      fullname,
      nationalityId,
      expeditionCityId,
      birthday,
    } = this.form.getRawValue();

    try {
      await this.saveData(
        identificationType,
        identification,
        email,
        phone,
        fullname,
        nationalityId,
        expeditionCityId,
        birthday
      );
      return await this.validateOnboardingToday();
    } catch (error: any) {
      if (error?.error?.err === 'nationality is blocked') {
        this.failMessage('A007-F: No se puede realizar su vinculación por este canal, por favor acérquese a una oficina o comuníquese con su asesor...');
        this.saveLog('Error', '00-nationality is blocked', null);
        this.ngOnInit();
      }
      return true;
    }
  }

  saveLog(step: string, message: string, data: any) {
    this._logRedebanSoyyoService.setLogRedebanSoyyo(step, message, data).subscribe({
      next: (response: any) => {
      },
      error: (error: any) => {
        this.validatePerson.set(true);
      }
    });
  }

  failMessage(description:string, title:string = 'Error', actionLabel: string = 'Reintentar', blocked: boolean = false) {
    this.titleError = title;
    this.descriptionError = description;
    this.errorActionLabel = actionLabel;
    this.identityBlocked = blocked;
    this.showErrorAdvisor = !blocked;
    this.showError.set(true);
    this.disabledButton = false;
    this._loaderService.hide();
  }

  saveData(
    identificationType: string | number,
    identification: string,
    email: string,
    phone: string,
    fullname: string,
    nationalityId: string | number,
    expeditionCityId?: number | null,
    birthday?: string | null
  ): Promise<void> {
    return lastValueFrom(
      this._securityService.setTypedPersonData(
        identificationType,
        identification,
        email,
        phone,
        fullname,
        nationalityId,
        expeditionCityId,
        birthday
      )
    ).then(() => undefined);
  }

  closeScreenError(){
    if (this.identityBlocked) {
      window.location.replace('https://www.fincomercio.com/');
      return;
    }
    this.showError.set(false);
    this.disabledButton = false;
  }

  async proceedToNextStep() {
    if (this.currentStep === this.STEP_CONFIRM_DATA_IN_CURRENT_MODAL) {
      this._loaderService.show('Validando información, por favor espere...');
      try {
        const blocked = await this.saveAndValidateBlock();
        if (blocked) {
          return;
        }
        this.currentStep = this.STEP_SHOW_CAMERA_IN_CURRENT_MODAL;
      } finally {
        this._loaderService.hide();
      }
    } else if (this.currentStep === this.STEP_SHOW_CAMERA_IN_CURRENT_MODAL) {
      this.showModal.set(false);
      this.currentStep = this.STEP_CONFIRM_DATA_IN_CURRENT_MODAL;
      this.requestCameraPermission();
    }
  }

  async verifyBlockIdentification(): Promise<boolean> {
    const identification = String(this.form.get('identification')?.value ?? '').trim();
    if (!identification) {
      return false;
    }

    try {
      const response: any = await lastValueFrom(
        this._securityService.checkBlockIdentification(identification)
      );

      if (response?.data === true) {
        this.canContinue = true;
        return false;
      }

      this.canContinue = false;
      this.showModal.set(false);
      this.failMessage(
        'No es posible continuar con su vinculación por este canal. Por favor acérquese a una oficina o comuníquese con su asesor...',
        'Error al validar tus datos'
      );
      return true;
    } catch (error) {
      console.error('ERROR: ', error);
      this.canContinue = false;
      this.showModal.set(false);
      this.failMessage(
        'No es posible continuar con su vinculación por este canal. Por favor acérquese a una oficina o comuníquese con su asesor...',
        'Error al validar tus datos'
      );
      return true;
    }
  }

  private requestCameraPermission(): void {
    if (!navigator.mediaDevices?.getUserMedia) {
      console.error('❌ Media API not supported in this browser');
      return;
    }

    if (!navigator.permissions?.query) {
      console.error('❌ Permissions API not supported in this browser');
      return;
    }

    from(
      navigator.permissions.query({ name: 'camera' as PermissionName })
    ).subscribe({
      next: (permissionStatus) => {
        if (permissionStatus.state === 'granted') {
          console.log('✅ Camera permission already granted');
          this.checkPercentages();
        } else if (permissionStatus.state === 'prompt') {
          this.requestExplicitPermission();
        } else {
          this.showAlert.set(true)
        }
      },
      error: () => {
        this.requestExplicitPermission();
      }
    });
  }

  private requestExplicitPermission(): void {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(stream => {
        stream.getTracks().forEach(track => track.stop());
        console.log('✅ Camera permission granted');
          this.checkPercentages();
      })
      .catch(error => {
        const errorMessage = this.getErrorMessage(error);
        this.showAlert.set(true);
        console.log(`❌ ${errorMessage}`);
      });
  }

  async onSubmitOlimpia(): Promise<void> {
    if(this.checkpoint === 'LIST_ERROR_06') {
      this.failMessage('122: No es posible continuar con su vinculación por este canal. Por favor acérquese a una oficina o comuníquese con su asesor...');
      return;
    }

    const identificationBlocked = await this.verifyBlockIdentification();
    if (identificationBlocked) {
      return;
    }

    const blocked = await this.validateOnboardingToday();
    if (blocked) {
      return;
    }

    const identification = this.form.value.identification;
    const email = this.form.value.email;
    const phone = this.form.value.phone;
    const fullname = this.form.value.fullname;
    const identificationType = this.form.value.identificationType;
    const cityBorn = this.form.value.cityBorn;
    const nationalityId = this.form.value.nationalityId;
    const expeditionCityId = this.form.value.expeditionCityId;
    const birthday = this.form.value.birthday;
    let documentType = 'CC';
    switch(identificationType) {
      case '1':
        documentType = 'CC';
        break;
      case '2':
        documentType = 'CE';
        break;
      case 1:
        documentType = 'CC';
        break;
      case 2:
        documentType = 'CE';
        break;
      default:
        documentType = 'CC';
        break;
    }
    this.canContinue = false;
    try {
      await this.saveData(
        identificationType,
        identification,
        email,
        phone,
        fullname,
        nationalityId,
        expeditionCityId,
        birthday
      );
    } catch (error: any) {
      if(error?.error?.err == 'nationality is blocked'){
        this.canContinue = false;
        this.failMessage('A007-F: No se puede realizar su vinculación por este canal, por favor acérquese a una oficina o comuníquese con su asesor...');
        this.saveLog('Error', '00-nationality is blocked', null);
        this.ngOnInit();
        return;
      }
      this.validatePerson.set(true);
      return;
    }
    this._loaderService.show('Redirigiendo a validación, por favor espere...');
    try {
      this.olimpiaService.getValidation(identificationType, identification, email, phone).subscribe({
        next: async (response: any) => {
          const data = response?.data;
          if (!data?.url || !data?.procesoConvenioGuid) {
            this.handleProviderStartFailure('OLIMPIA', response);
            return;
          }
          this.processGuid = data.procesoConvenioGuid
          this.validationOlimpiaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
          this._loaderService.hide();
          this.showOlimpiaSignal.set(true);
          this.startInterval();
        },error: async (error: any) => {
          this.handleProviderStartFailure('OLIMPIA', error);
        }
      });
    } catch (error) {
      this.handleProviderStartFailure('OLIMPIA', error);
    }
  }

  startInterval() {
    setTimeout(() => {
      this.intervalId = setInterval(() => {
        this.olimpiaService.verifyValidation(this.processGuid).subscribe({
          next: async (response: any) => {
            const data = response.data;
            if(data.finalizado || data.cancelado){
              this.hideOlimpia();
              if(data.aprobado) {
                sessionStorage.setItem('olimpiaPassed', '1');
                localStorage.setItem('olimpiaPassed', '1');
                this.showWowSignal.set(true);
              } else {
                this.failMessage('116: Autenticación incorrecta, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
              }
            }
          },error: async (error: any) => {
            console.log(error);
          }
        });
      }, 10000);
    }, 60000);
  }

  async onSubmitBecome() {
    if (this.checkpoint === "LIST_ERROR_06") {
      this.failMessage('A007: No se puede realizar su vinculación por este canal, por favor acérquese a una oficina o comuníquese con su asesor...');
      this.saveLog('Error', '00-LIST_ERROR_06', null);
      this.ngOnInit();
      return;
    }

    const blockedId = await this.verifyBlockIdentification();
    if (blockedId) {
      return;
    }

    const blocked = await this.validateOnboardingToday();
    if (blocked) {
      return;
    }

    const identification = this.form.value.identification;
    const email = this.form.value.email;
    const phone = this.form.value.phone;
    const fullname = this.form.value.fullname;
    const identificationType = this.form.value.identificationType;
    const nationalityId = this.form.value.nationalityId;
    const expeditionCityId = this.form.value.expeditionCityId;
    const birthday = this.form.value.birthday;

    this.canContinue = false;
    try {
      await this.saveData(
        identificationType,
        identification,
        email,
        phone,
        fullname,
        nationalityId,
        expeditionCityId,
        birthday
      );
    } catch (error: any) {
      if (error?.error?.err == 'nationality is blocked') {
        this.canContinue = false;
        this.failMessage('A007-F: No se puede realizar su vinculación por este canal, por favor acérquese a una oficina o comuníquese con su asesor...');
        this.saveLog('Error', '00-nationality is blocked', null);
        this.ngOnInit();
        return;
      }
      this.validatePerson.set(true);
      return;
    }

    this._loaderService.show('Abriendo validación Become, por favor espere...');
    try {
      const response: any = await lastValueFrom(
        this.becomeService.startSession(identificationType)
      );
      if (response?.data?.reused) {
        this.applyBecomeResult({ finalizado: true, aprobado: true });
        return;
      }
      await this.loadBecomeSdk();
      const data = response?.data;
      if (!data?.userId || !data?.accessToken) {
        this.handleProviderStartFailure('BECOME', response);
        return;
      }
      this.becomeSession = data;
      this.becomeUserId = data.userId;
      this.showBecomeSignal.set(false);
      this.mountBecomeButton();
    } catch (error: any) {
      if (error?.status === 403 && error?.error?.motivo === 'FRAUDE') {
        this.applyBecomeResult({ motivo: 'FRAUDE', finalizado: true, aprobado: false });
        return;
      }
      this.handleProviderStartFailure('BECOME', error);
    }
  }

  private loadBecomeSdk(): Promise<void> {
    if (customElements.get('become-button')) {
      return Promise.resolve();
    }
    if (this.becomeSdkLoading) {
      return this.becomeSdkLoading;
    }

    this.becomeSdkLoading = new Promise<void>((resolve, reject) => {
      const existing = document.querySelector('script[data-become-sdk="v2"]') as HTMLScriptElement | null;
      if (existing) {
        existing.addEventListener('load', () => resolve());
        existing.addEventListener('error', () => reject(new Error('Become SDK load error')));
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://onboarding-v2.svi.becomedigital.net/resources/button.js';
      script.async = true;
      script.dataset['becomeSdk'] = 'v2';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Become SDK load error'));
      document.head.appendChild(script);
    });

    return this.becomeSdkLoading;
  }

  private mountBecomeButton() {
    if (!this.becomeSession) {
      return;
    }

    this.becomeFrameOpened = false;
    this.becomeCycleFinished = false;
    this.cleanupBecomeButton();
    this._loaderService.show('Abriendo validación Become, por favor espere...');

    const button = document.createElement('become-button');
    const session = this.becomeSession;
    const host = button as HTMLElement & {
      userId?: string;
      token?: string;
      contractId?: string;
      country?: string;
      docType?: string;
    };
    host.userId = session.userId;
    host.token = session.accessToken;
    host.contractId = String(session.contractId);
    host.country = session.country || 'CO';
    host.docType = session.docType || 'national-id';
    button.setAttribute('userId', session.userId);
    button.setAttribute('contractId', String(session.contractId));
    button.setAttribute('token', session.accessToken);
    button.setAttribute('country', session.country || 'CO');
    button.setAttribute('docType', session.docType || 'national-id');
    // signupHost debe ser *.svi.becomedigital.net: la licencia Microblink/WASM
    // no admite application ID "localhost".
    button.style.display = 'block';
    button.style.margin = '0 auto';
    button.style.width = '240px';
    button.style.height = '72px';
    button.style.opacity = '0';
    button.style.overflow = 'hidden';

    button.addEventListener('become:userFinishedSdk', ((event: CustomEvent) => {
      const detail = event.detail || {};
      this.becomeUserId = detail.userId || this.becomeUserId;
      this.becomeCycleFinished = true;
      this.clearBecomeAutoOpenTimers();
      this.showFaceGuide.set(false);
      this._loaderService.show('Validando identidad Become, por favor espere...');
      this.startBecomeInterval();
    }) as EventListener);

    button.addEventListener('become:exitedSdk', (() => {
      if (this.becomeCycleFinished || !this.becomeFrameOpened) {
        return;
      }
      this.clearBecomeAutoOpenTimers();
      this.hideBecome();
      this._loaderService.hide();
      this.failMessage('Validación Become cancelada. Puede intentarlo de nuevo.');
    }) as EventListener);

    const container = document.getElementById('become-sdk-container');
    if (container) {
      container.appendChild(button);
    } else {
      document.body.appendChild(button);
    }
    this.becomeButtonEl = button;
    this.startBecomeFrameObserver(() => {
      this.becomeFrameOpened = true;
      this.showFaceGuide.set(false);
      this.clearBecomeAutoOpenTimers();
      this._loaderService.hide();
    });

    let attempts = 0;
    let clicked = false;
    const tryClick = () => {
      if (clicked || this.becomeFrameOpened || document.querySelector('become-frame')) {
        return;
      }
      const host = button as HTMLElement & { userId?: string; token?: string };
      if (host.userId && host.token) {
        clicked = true;
        host.click();
        return;
      }
      attempts++;
      if (attempts < 25) {
        this.becomeAutoClickTimer = setTimeout(tryClick, 200);
        return;
      }
      this._loaderService.hide();
    };
    this.becomeAutoClickTimer = setTimeout(tryClick, 200);
  }

  private clearBecomeAutoOpenTimers() {
    if (this.becomeAutoClickTimer) {
      clearTimeout(this.becomeAutoClickTimer);
      this.becomeAutoClickTimer = null;
    }
  }

  private startBecomeFrameObserver(onOpened?: () => void) {
    this.stopBecomeFrameObserver();

    const patchIframes = (root: ParentNode | ShadowRoot) => {
      root.querySelectorAll('iframe').forEach((iframe) => {
        const currentAllow = iframe.getAttribute('allow') || '';
        const required = ['camera', 'microphone', 'fullscreen', 'autoplay'];
        const missing = required.filter((item) => !currentAllow.includes(item));
        if (missing.length > 0 || !currentAllow) {
          iframe.setAttribute(
            'allow',
            'camera; microphone; fullscreen; autoplay; clipboard-write'
          );
        }
        iframe.setAttribute('allowfullscreen', 'true');
      });
    };

    const scan = () => {
      const frames = document.querySelectorAll('become-frame');
      if (frames.length > 0 && onOpened) {
        onOpened();
        // Solo una vez: a partir de aquí el frame ya es visible.
        onOpened = undefined;
      }
      frames.forEach((frame) => {
        patchIframes(document);
        if (frame.shadowRoot) {
          patchIframes(frame.shadowRoot);
        }
      });
      patchIframes(document);
    };

    this.becomeFrameObserver = new MutationObserver(() => scan());
    this.becomeFrameObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['allow', 'src'],
    });
    scan();
  }

  private stopBecomeFrameObserver() {
    if (this.becomeFrameObserver) {
      this.becomeFrameObserver.disconnect();
      this.becomeFrameObserver = null;
    }
  }

  private cleanupBecomeButton() {
    if (this.becomeButtonEl?.parentElement) {
      this.becomeButtonEl.parentElement.removeChild(this.becomeButtonEl);
    }
    this.becomeButtonEl = null;
    const container = document.getElementById('become-sdk-container');
    if (container) {
      container.innerHTML = '';
    }
    document.querySelectorAll('become-frame').forEach((frame) => frame.remove());
  }

  private applyBecomeResult(data: any): void {
    this.hideBecome();
    this._loaderService.hide();
    if (data?.motivo === 'FRAUDE') {
      this.failMessage(
        'No es posible continuar con su solicitud.',
        'Solicitud no disponible',
        'Cerrar',
        true,
      );
      return;
    }
    if (data?.motivo === 'CORREGIR_DATOS') {
      this.failMessage(
        'El número de cédula no coincide. Corríjalo en el formulario y vuelva a validar su identidad.',
        'Corrija la cédula',
        'Corregir cédula',
      );
      return;
    }
    if (data?.aprobado) {
      sessionStorage.setItem('olimpiaPassed', '1');
      localStorage.setItem('olimpiaPassed', '1');
      this.showWowSignal.set(true);
      return;
    }
    this.failMessage(
      'La validación de identidad no fue exitosa. Repita la captura del documento y del rostro.',
      'Repita la validación',
    );
  }

  startBecomeInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    setTimeout(() => {
      this.intervalId = setInterval(() => {
        this.becomeService.verifyValidate(this.becomeUserId).subscribe({
          next: async (response: any) => {
            const data = response.data;
            if (data.finalizado || data.cancelado) {
              this.applyBecomeResult(data);
            }
          },
          error: async (error: any) => {
            if (error?.status === 403 && error?.error?.motivo === 'FRAUDE') {
              this.applyBecomeResult({ motivo: 'FRAUDE', finalizado: true, aprobado: false });
              return;
            }
            console.error(error);
          }
        });
      }, 10000);
    }, 15000);
  }

  private getErrorMessage(error: DOMException): string {
    switch (error.name) {
      case 'NotAllowedError':
        return 'Camera permission denied by user';
      case 'NotFoundError':
        return 'No camera device found';
      case 'NotReadableError':
        return 'Camera is not available or being used by another application';
      case 'OverconstrainedError':
        return 'Cannot satisfy the requested constraints';
      case 'SecurityError':
        return 'Camera permission is disabled for security reasons';
      case 'AbortError':
        return 'Permission request was aborted';
      default:
        return `Error requesting permission: ${error.message}`;
    }
  }

  toggleFaceGuide() {
    this.showFaceGuide.update(value => !value);
  }
}
